module.exports = __webpack_public_path__ + "static/dispositivo_de_gestion_remota-3922e2cd249c9b1cd0261abe565bc7b3.png";